export { version } from './src/package.js'
import { highlight } from './src/highlight.js'

if (typeof jQuery != 'undefined') {
  jQuery.extend(jQuery.fn, {
    highlight: highlight
  })
}
